export default {
  saveEmailEvent: 'save-email',
  splitters: {
    comments: /[;\r\n]+/,
    seo_keywords: /[,;\r\n]+/,
  },
};
